// Empresas (tienda v5) — port de maquetas/tienda-v5-empresas.html a JSX.
// Página 11 de Fase 3. Ruta /empresas (+ dev alias). Acento GOLD (toda la maqueta de
// esta página es gold, igual que Porteros). CSS co-locado bajo .tv5-page-empresas.
//
// Reusa shared: TopNav(gold) / Breadcrumb / Footer(gold) / BottomNav / MiniBar.
// Elementos (maqueta pulida Fase 1): hero + 2 CTAs, 3 segmentos (Comercios/Oficinas/
// Administradoras), ventajas (6), "Cómo empezamos" (3 pasos), casos (2 testimonios), CTA final.
//
// CTA "Pedir cotización" → /cotizar (form real de cotización en prod, inserta en
// consultas_comerciales). WhatsApp como CTA secundario, tal como la maqueta.
// La maqueta no tiene FAQ en esta página → no se agrega.
import { Link } from 'react-router-dom';
import { TopNav, Breadcrumb, Footer, BottomNav, MiniBar } from '../../components/tienda-v5';
import { TV5_ROUTES, TV5_EXTERNAL } from '../../components/tienda-v5/routes';

const COTIZAR_ROUTE = '/cotizar'; // landing pública de cotización (existente en prod)
const WA_EMPRESA = `${TV5_EXTERNAL.whatsapp}?text=${encodeURIComponent('Hola! Quiero una cotización para mi empresa.')}`;

const SEGMENTOS = [
  { icon: '🏪', h: 'Comercios y locales', p: 'Restaurantes, cafés, gimnasios, peluquerías, retail. Limpiezas frecuentes con consumos altos que reponer sin fallar.' },
  { icon: '🏢', h: 'Oficinas y coworkings', p: 'Baños, cocinas, escritorios. Kit fijo mensual con lo que se gasta. Sin corridas de último momento.' },
  { icon: '🏘️', h: 'Administradoras', p: 'Zonas comunes de edificios: portería, escaleras, ascensores. Consolidamos facturación por edificio o global.' },
];

const VENTAJAS = [
  { icon: '📋', h: 'Propuesta a medida', p: 'Analizamos qué usás, cuánto rinde y armamos el kit ideal para tu operación.' },
  { icon: '📄', h: 'e-Factura DGI', p: 'Comprobante electrónico automático cada mes al email registrado. Todo trazable.' },
  { icon: '🔓', h: 'Sin permanencia', p: 'Cambiás, ampliás o cancelás cuando quieras. Ninguna cláusula rara.' },
  { icon: '🚚', h: 'Entrega sin costo', p: 'Repartimos el día fijo de tu zona. Si necesitás fuera de fecha, express con costo.' },
  { icon: '💳', h: 'Pago flexible', p: 'Transferencia, MP o tarjeta empresarial. Con administradoras: una factura consolidada.' },
  { icon: '🤝', h: 'Contacto directo', p: 'Un mismo contacto siempre. Sin call centers, sin tickets, sin bots. WhatsApp o teléfono.' },
];

const PASOS = [
  { n: '1', h: 'Nos contactás', p: 'Formulario de cotización o WhatsApp. Nos contás qué tipo de negocio tenés y qué usás hoy.' },
  { n: '2', h: 'Visita o Meet', p: 'Nos juntamos (en tu local o por Meet). Vemos tu operación real. Te armamos propuesta con precio.' },
  { n: '3', h: 'Recibís cada mes', p: 'Aceptás la propuesta, agendás el día. Al mes siguiente ya está pasando por tu puerta.' },
];

// Testimonios con razón social anonimizada (placeholders de la maqueta, aún sin confirmar).
const CASOS = [
  { icon: '🥗', quote: 'Nos ahorra mucho tiempo. Antes uno de nosotros iba al mayorista una vez por semana. Ahora llega solo a la puerta.', autor: '— ••••••• SAS · Vianda saludable · Pocitos' },
  { icon: '🍕', quote: 'Consumíamos mucho papel y detergente. Con Limpack tenemos un kit fijo mensual, sin fallas.', autor: '— ••••••• SA · Restaurante · Punta Carretas' },
];

export default function Empresas() {
  return (
    <div className="tv5-page-empresas">
      <style>{EMPRESAS_CSS}</style>

      <TopNav active="empresas" accent="gold" />
      <Breadcrumb backHref={TV5_ROUTES.home} backLabel="Home" current="Empresas" />

      <main>
        {/* HERO */}
        <section className="em-hero">
          <span className="em-eyebrow">🏢 Empresas · Administradoras · Comercios</span>
          <h1>Tu local o tus edificios,<br />resueltos cada mes.</h1>
          <p>Nos encargamos del abastecimiento de limpieza. Vos te ocupás de lo que sabés hacer. Cotización sin compromiso, sin permanencia, con e-Factura DGI.</p>
          <div className="em-hero-ctas">
            <Link to={COTIZAR_ROUTE} className="em-btn-primary">Pedir cotización →</Link>
            <a href={WA_EMPRESA} target="_blank" rel="noopener noreferrer" className="em-btn-secondary">💬 WhatsApp</a>
          </div>
        </section>

        {/* SEGMENTOS */}
        <section className="em-seccion">
          <h2>¿Para quién?</h2>
          <p className="em-seccion-sub">Tres perfiles distintos, un servicio a medida.</p>
          <div className="em-segmentos">
            {SEGMENTOS.map((s) => (
              <div className="em-segmento" key={s.h}>
                <div className="em-segmento-icon">{s.icon}</div>
                <h3>{s.h}</h3>
                <p>{s.p}</p>
              </div>
            ))}
          </div>
        </section>

        {/* VENTAJAS */}
        <section className="em-seccion">
          <h2>Lo que te ofrecemos</h2>
          <p className="em-seccion-sub">Servicio profesional, sin ataduras.</p>
          <div className="em-ventajas">
            <div className="em-ventajas-grid">
              {VENTAJAS.map((v) => (
                <div className="em-ventaja" key={v.h}>
                  <div className="em-ventaja-icon">{v.icon}</div>
                  <div className="em-ventaja-content">
                    <h4>{v.h}</h4>
                    <p>{v.p}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CÓMO EMPEZAMOS */}
        <section className="em-seccion">
          <h2>Cómo empezamos</h2>
          <p className="em-seccion-sub">3 pasos para tener tu servicio funcionando.</p>
          <div className="em-pasos">
            {PASOS.map((p) => (
              <div className="em-paso" key={p.n}>
                <span className="em-paso-num">{p.n}</span>
                <h3>{p.h}</h3>
                <p>{p.p}</p>
              </div>
            ))}
          </div>
        </section>

        {/* CASOS */}
        <section className="em-seccion">
          <h2>Quienes ya nos eligieron</h2>
          <p className="em-seccion-sub">Empresas que apoyaron el proyecto desde el arranque.</p>
          {CASOS.map((c) => (
            <div className="em-caso" key={c.autor}>
              <div className="em-caso-icon">{c.icon}</div>
              <div>
                <div className="em-caso-quote">"{c.quote}"</div>
                <div className="em-caso-autor">{c.autor}</div>
              </div>
            </div>
          ))}
        </section>

        {/* CTA FINAL */}
        <div className="em-cta-fin">
          <h3>Empezamos con una cotización</h3>
          <p>Sin compromiso, sin permanencia, sin sorpresas. Te contactamos en 24 hs.</p>
          <div className="em-cta-fin-btns">
            <Link to={COTIZAR_ROUTE} className="em-cta-fin-primary">Pedir cotización →</Link>
            <a href={WA_EMPRESA} target="_blank" rel="noopener noreferrer" className="em-cta-fin-secondary">💬 WhatsApp</a>
          </div>
        </div>
      </main>

      <MiniBar checkoutHref={TV5_ROUTES.checkout} />
      <Footer accent="gold" />
      <BottomNav active="empresas" />
    </div>
  );
}

const EMPRESAS_CSS = `
.tv5-page-empresas {
  --tv5e-navy:#1A3461; --tv5e-teal:#00A8B5; --tv5e-gold:#C5A059; --tv5e-green:#10B981;
  --tv5e-bg:#0A1424; --tv5e-card:rgba(255,255,255,0.04); --tv5e-border:rgba(255,255,255,0.08);
  --tv5e-text:#F8F6F1; --tv5e-muted:rgba(248,246,241,0.65); --tv5e-dim:rgba(248,246,241,0.45);
  --safe-bottom:env(safe-area-inset-bottom, 0px);
  background:var(--tv5e-bg); color:var(--tv5e-text); min-height:100vh; position:relative;
  overflow-x:clip; max-width:100%;
  font-family:'Inter',-apple-system,BlinkMacSystemFont,sans-serif;
  padding-bottom:calc(72px + var(--safe-bottom));
}
.tv5-page-empresas::before {
  content:''; position:fixed; inset:0; pointer-events:none; z-index:0;
  background:
    radial-gradient(circle at 20% 10%, rgba(197,160,89,0.12) 0%, transparent 40%),
    radial-gradient(circle at 80% 60%, rgba(26,52,97,0.20) 0%, transparent 40%);
}
.tv5-page-empresas main { position:relative; z-index:1; }
@media (min-width:900px){ .tv5-page-empresas { padding-bottom:0; } }

/* HERO */
.tv5-page-empresas .em-hero { padding:40px 20px 20px; text-align:center; max-width:900px; margin:0 auto; }
.tv5-page-empresas .em-eyebrow { display:inline-block; color:var(--tv5e-gold); font-size:11px; font-weight:800; letter-spacing:0.15em; text-transform:uppercase; padding:6px 14px; background:rgba(197,160,89,0.1); border:1px solid rgba(197,160,89,0.3); border-radius:999px; margin-bottom:14px; }
.tv5-page-empresas .em-hero h1 { font-size:clamp(30px, 6.5vw, 52px); font-weight:800; letter-spacing:-0.03em; line-height:1.05; margin-bottom:14px; background:linear-gradient(135deg, var(--tv5e-text) 0%, var(--tv5e-gold) 100%); -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
.tv5-page-empresas .em-hero p { color:var(--tv5e-muted); font-size:15px; max-width:580px; margin:0 auto 24px; line-height:1.6; }
.tv5-page-empresas .em-hero-ctas { display:flex; gap:10px; justify-content:center; flex-wrap:wrap; }
.tv5-page-empresas .em-btn-primary { display:inline-flex; align-items:center; gap:6px; background:linear-gradient(135deg, var(--tv5e-gold) 0%, #D4B370 100%); color:var(--tv5e-navy); padding:14px 26px; border-radius:10px; font-weight:800; font-size:14px; text-decoration:none; box-shadow:0 8px 24px rgba(197,160,89,0.35); min-height:44px; transition:transform 0.2s; }
.tv5-page-empresas .em-btn-secondary { display:inline-flex; align-items:center; gap:6px; background:rgba(255,255,255,0.06); border:1px solid var(--tv5e-border); color:var(--tv5e-text); padding:14px 24px; border-radius:10px; font-weight:700; font-size:14px; text-decoration:none; min-height:44px; transition:background 0.2s; }
@media (hover:hover){
  .tv5-page-empresas .em-btn-primary:hover { transform:translateY(-2px); }
  .tv5-page-empresas .em-btn-secondary:hover { background:rgba(255,255,255,0.1); }
}

/* SECCIÓN */
.tv5-page-empresas .em-seccion { padding:40px 20px; max-width:1000px; margin:0 auto; }
.tv5-page-empresas .em-seccion h2 { font-size:clamp(22px, 4vw, 32px); font-weight:800; letter-spacing:-0.02em; margin-bottom:8px; text-align:center; }
.tv5-page-empresas .em-seccion-sub { text-align:center; color:var(--tv5e-muted); font-size:14px; margin:0 auto 32px; max-width:500px; line-height:1.5; }

/* SEGMENTOS */
.tv5-page-empresas .em-segmentos { display:grid; gap:16px; }
@media (min-width:640px){ .tv5-page-empresas .em-segmentos { grid-template-columns:repeat(3, 1fr); } }
.tv5-page-empresas .em-segmento { background:linear-gradient(135deg, rgba(197,160,89,0.08) 0%, rgba(255,255,255,0.02) 100%); border:1px solid rgba(197,160,89,0.25); border-radius:18px; padding:26px 22px; display:flex; flex-direction:column; gap:12px; transition:transform 0.3s, border-color 0.3s, box-shadow 0.3s; }
@media (hover:hover){ .tv5-page-empresas .em-segmento:hover { transform:translateY(-4px); border-color:var(--tv5e-gold); box-shadow:0 12px 32px rgba(197,160,89,0.15); } }
.tv5-page-empresas .em-segmento-icon { width:52px; height:52px; border-radius:14px; background:rgba(197,160,89,0.15); border:1px solid rgba(197,160,89,0.3); display:flex; align-items:center; justify-content:center; font-size:26px; }
.tv5-page-empresas .em-segmento h3 { font-size:18px; font-weight:800; letter-spacing:-0.01em; }
.tv5-page-empresas .em-segmento p { color:var(--tv5e-muted); font-size:13px; line-height:1.5; }

/* VENTAJAS */
.tv5-page-empresas .em-ventajas { background:linear-gradient(135deg, rgba(0,168,181,0.08) 0%, rgba(197,160,89,0.04) 100%); border:1px solid rgba(0,168,181,0.25); border-radius:20px; padding:32px 24px; }
.tv5-page-empresas .em-ventajas-grid { display:grid; gap:20px; }
@media (min-width:640px){ .tv5-page-empresas .em-ventajas-grid { grid-template-columns:repeat(2, 1fr); } }
.tv5-page-empresas .em-ventaja { display:flex; gap:14px; align-items:flex-start; padding:16px; background:rgba(0,0,0,0.15); border-radius:12px; }
.tv5-page-empresas .em-ventaja-icon { width:40px; height:40px; border-radius:10px; background:rgba(0,168,181,0.15); border:1px solid rgba(0,168,181,0.3); display:flex; align-items:center; justify-content:center; font-size:20px; flex-shrink:0; }
.tv5-page-empresas .em-ventaja-content h4 { font-size:14px; font-weight:800; margin-bottom:4px; letter-spacing:-0.01em; }
.tv5-page-empresas .em-ventaja-content p { color:var(--tv5e-muted); font-size:12px; line-height:1.5; }

/* PASOS */
.tv5-page-empresas .em-pasos { display:grid; gap:14px; }
@media (min-width:640px){ .tv5-page-empresas .em-pasos { grid-template-columns:repeat(3, 1fr); } }
.tv5-page-empresas .em-paso { background:var(--tv5e-card); border:1px solid var(--tv5e-border); border-radius:14px; padding:22px 20px; position:relative; }
.tv5-page-empresas .em-paso-num { display:inline-flex; align-items:center; justify-content:center; width:32px; height:32px; border-radius:50%; background:rgba(197,160,89,0.15); color:var(--tv5e-gold); border:1px solid rgba(197,160,89,0.3); font-weight:900; font-size:14px; margin-bottom:12px; }
.tv5-page-empresas .em-paso h3 { font-size:17px; font-weight:800; margin-bottom:6px; letter-spacing:-0.01em; }
.tv5-page-empresas .em-paso p { color:var(--tv5e-muted); font-size:13px; line-height:1.5; }

/* CASOS */
.tv5-page-empresas .em-caso { background:linear-gradient(135deg, rgba(197,160,89,0.06) 0%, rgba(255,255,255,0.02) 100%); border:1px solid var(--tv5e-border); border-radius:18px; padding:26px 22px; display:grid; gap:20px; margin-bottom:16px; }
@media (min-width:640px){ .tv5-page-empresas .em-caso { grid-template-columns:80px 1fr; align-items:center; gap:24px; } }
.tv5-page-empresas .em-caso-icon { width:80px; height:80px; border-radius:16px; background:rgba(197,160,89,0.12); border:1px solid rgba(197,160,89,0.3); display:flex; align-items:center; justify-content:center; font-size:40px; margin:0 auto; }
.tv5-page-empresas .em-caso-quote { font-size:15px; font-style:italic; color:var(--tv5e-text); line-height:1.5; margin-bottom:10px; }
.tv5-page-empresas .em-caso-autor { font-size:12px; color:var(--tv5e-gold); font-weight:700; }

/* CTA FINAL */
.tv5-page-empresas .em-cta-fin { max-width:700px; margin:60px auto 0; padding:40px 24px; background:linear-gradient(135deg, var(--tv5e-gold) 0%, #D4B370 100%); border-radius:20px; text-align:center; color:var(--tv5e-navy); box-shadow:0 20px 60px rgba(197,160,89,0.35); }
.tv5-page-empresas .em-cta-fin h3 { font-size:26px; font-weight:900; margin-bottom:8px; letter-spacing:-0.02em; }
.tv5-page-empresas .em-cta-fin p { font-size:14px; margin-bottom:24px; opacity:0.85; }
.tv5-page-empresas .em-cta-fin-btns { display:flex; gap:10px; justify-content:center; flex-wrap:wrap; }
.tv5-page-empresas .em-cta-fin-primary { background:var(--tv5e-navy); color:#fff; padding:14px 26px; border-radius:10px; font-weight:800; font-size:14px; text-decoration:none; display:inline-flex; align-items:center; gap:6px; min-height:44px; transition:transform 0.2s; }
.tv5-page-empresas .em-cta-fin-secondary { background:rgba(255,255,255,0.7); color:var(--tv5e-navy); padding:14px 22px; border-radius:10px; font-weight:800; font-size:14px; text-decoration:none; display:inline-flex; align-items:center; gap:6px; min-height:44px; transition:background 0.2s; }
@media (hover:hover){
  .tv5-page-empresas .em-cta-fin-primary:hover { transform:translateY(-2px); }
  .tv5-page-empresas .em-cta-fin-secondary:hover { background:#fff; }
}

/* Reduced motion */
@media (prefers-reduced-motion:reduce){
  .tv5-page-empresas .em-btn-primary, .tv5-page-empresas .em-btn-secondary,
  .tv5-page-empresas .em-segmento, .tv5-page-empresas .em-cta-fin-primary,
  .tv5-page-empresas .em-cta-fin-secondary { transition:none; }
}
`;
